module.exports = __webpack_public_path__ + "a6b8cf939f87355186a5930d22ed7f32.svg";